import './classic/darkMode.st.css';
import { st, classes } from './classic.st.css';
export default (function (_ref) {
  var darkMode = _ref.darkMode;
  return st(classes.root, {
    darkMode: darkMode
  });
});